import { defineStore } from 'pinia'

export const ListOfReports = defineStore({
    id: 'mr_list',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const ItemUUID = defineStore({
    id: 'mr_save_uuid',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const ItemName = defineStore({
    id: 'mr_save_name',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
export const ItemDesc = defineStore({
    id: 'mr_save_desc',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
export const ItemData  = defineStore({
    id: 'mr_save_data',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})